// extracted by mini-css-extract-plugin
export var Banner = "Banner-module--Banner--sLHuc";
export var FixedHeader = "Banner-module--FixedHeader--GUNLg";
export var BannerText = "Banner-module--BannerText--K3jqN";
export var DashboardScreen = "Banner-module--DashboardScreen--DpbG6";
export var ButtonsWrapper = "Banner-module--ButtonsWrapper--OMbOg";